
<script setup>

import { computed, ref } from 'vue'

import moreInfoUrl from 'url:../../images/more-info.svg'

import closeUrl from 'url:../../images/close.svg'

const { card, bgColor } = defineProps( [ 'card', 'bgColor' ] )

const titleRef = ref( null )

const dataFound = computed( () => card?.localValue || card?.localValue === 0 )

</script>

<template>

  <div class="min-h-50 hover:cursor-pointer group">

    <div class="bg-white flex flex-col rounded-md shadow-md h-full relative @container" v-if="!card?.moreInfo.active">

      <div 

        :class="[ 

          card?.alert ? 'bg-red' : `${bgColor}` ,
          
          card?.alert || card?.tab === 'bloodstream-infections' ? 'text-white' : 'text-neutral-900',

          'rounded-t-md flex items-center justify-center px-4'

        ]"

      >

        <h2 ref="titleRef" class="font-bold text-center uppercase py-1.5 px-4 min-h-10 flex items-center text-sm md:text-base" >

          <div>
            
            <span v-html="card?.title"></span>
            
            <sup class="ml-1">{{ card?.reference }}</sup>
            
          </div>
        
        </h2>

        <div class="absolute end-0 mr-2 @xs:mr-4">
          
          <img class="size-5 group-hover:brightness-85" :src="moreInfoUrl" />

        </div>

      </div>

      <div :class="[ card?.alert ? 'border-red' : 'border-white', 'flex flex-col items-center justify-center gap-4 border-2 p-4 rounded-b-md border-t-0 h-full' ]">

        <div class="flex gap-2.5 items-center text-[#373737]" v-if="dataFound" >

          <p class="font-bold text-5xl @2xs:text-6xl flex" :class="{ 'text-red' : card?.alert }">
            
            <span>{{ card?.localValue }}</span>

            <span v-if="card?.symbol">&percnt;</span>
          
          </p>

          <p class="text-md @2xs:text-lg max-w-35 @2xs:max-w-40 leading-5">{{ card?.description }}</p>

        </div>

        <div class="flex items-center text-[#373737]" v-else>

          <p class="font-bold text-4xl @2xs:text-6xl flex">N/A</p>

        </div>

        <p class="text-neutral-500 italic text-center" v-if="dataFound" >

          <span v-if="card?.alert">Above&nbsp;</span>

          <span>{{ card?.nationalValue }}</span>
          
          <span v-if="card?.symbol">&percnt;</span>
          
          National Average
          
        </p>

        <p class="text-neutral-500 italic text-center" v-else>

          Data Not Available

        </p>

      </div> 

    </div>

    <div v-if="card?.moreInfo?.active" class="bg-white px-4 pb-4 rounded-md shadow-md space-y-3 h-full flex flex-col">

      <div class="flex justify-between items-center h-10 py-2 border-b border-[#E4E4E4]">

        <h2 class="text-[#373737] font-bold text-sm">What does this data mean?</h2>
        
        <span class="rounded-full group-hover:bg-neutral-200 p-1 flex items-center justify-center">
          
          <img class="size-3" :src="closeUrl" />
          
        </span>

      </div>

      <div class="grow flex flex-col gap-4">
        
        <div>
      
           <p class="text-[#373737] text-sm leading-4" v-html="card?.moreInfo?.description"></p>
      
        </div>

        <div v-if="card?.moreInfo?.url">
      
          <p class="italic text-neutral-500 text-xs font-bold">Source:</p>

          <a :href=card?.moreInfo?.url @click.stop target="_blank" class="italic text-neutral-500 text-xs hover:underline">

            <p>{{ card?.moreInfo?.source }}</p>

          </a>
      
        </div>
      
      </div>

    </div>

    <div v-if="card?.moreInfo.updatedAt"
    
      :class="[ 'mt-4 text-sm text-center', card?.moreInfo.updatedAt.alert ? 'text-[#69a03b] font-semibold' : 'text-black/35' ]">
      
      {{ card?.moreInfo.updatedAt.message }}
    
    </div>

  </div>

</template>